import { Rewards } from '@components';

import './style.scss';

export function RewardsPage() {
  return (
    <div className="rewards-page">
      <div className="rewards-page__main">
        <Rewards />
      </div>
    </div>
  );
}
